import * as React from 'react';
import { FC, Fragment, useEffect } from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    DateInput,
    downloadCSV,
    EmailField,
    Filter,
    List,
    SearchInput,
    SelectInput,
    TextField,
    NumberInput,
    usePermissions,
    useTranslate,
    TextInput,
    ReferenceInput,
    ReferenceField,
    SelectField
} from 'react-admin';

import ListActions from '../components/actions';
import BulkDeleteButton from './actionsBulkDelete';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import ListEmpty from '../components/listEmpty';
import { FilterProps, PermissionsType } from "../../types";
import ListPagination from "../components/ListPagination";
import CustomizableDatagrid from '../components/CustomizableDatagrid';
import StatusField from './StatusField';
import { useHistory } from 'react-router';

const exporter = async (items: any,fetchRelatedRecords: any) => {
    console.log('items',items);
    
    var itemsForExport = items.map((item: any) => {
        return [item.id,item.firstname,item.lastname,item.firstname_kana,item.lastname_kana,item.post_code,item.pref,item.city,item.address,item.phone,item.email,item.image_url,item.nickname,item.birthday,item.gender,item.status,item.varified,item.created,item.created_by,item.note,item.account_id];
    });
    // await fetchRelatedRecords(items, 'account_id', 'account').then((account: any) => {
    //     const data_account = items.map((item: any) => (
    //       {
    //         ...item,
    //         account_id: item.account_id ? account[item.account_id].name : '',
    //       }
    //     ));
    //     itemsForExport = data_account;
    //   });
    const csv = '\uFEFF' + convertToCSV({
        data: itemsForExport,
        encoding: 'CP932',
        fields: [ "ID", "名", "姓", "メイ", "セイ", '郵便番号', '都道府県', '市区町村', '住所', '電話番号', "メールアドレス", 'プロフィール画像', 'ニックネーム', '生年月日', "性別", 'ステータス', 'メールアドレス確認キー', '作成日', '作成者', '備考', '団体'],
    });
    downloadCSV(csv, 'account_owner');
};
const UserBulkActionButtons = (props: JSX.IntrinsicAttributes) => {
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    return (
        <Fragment>
            {(role ==='client_admin' || role ==='admin') && (permission?.permission_approve === true || permission?.permission_all === true) && <BulkDeleteButton {...props} />}
        </Fragment>
    )
};

const UserFilter: FC<Omit<FilterProps, 'children'>> = props => {
    const translate = useTranslate();
    return (
        <Filter {...props}>
            <NumberInput source="id@_eq" label={translate('user_list.id')} alwaysOn />
            <SearchInput source="firstname,lastname,firstname_kana,lastname_kana,email,post_code,pref,city,address,phone,nickname,note" alwaysOn />
        </Filter>
    )
};

const UserList = (props: any) => {
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const role = permissions?.role;
    const permission = permissions?.list_permission as PermissionsType;
    let edit = (permission?.permission_create_edit == true || permission?.permission_all == true) ? 'edit': '';
    const history = useHistory();
    useEffect( () => {
        history.location.pathname = '/account_owner';
    },[props]);
    const STATUS = [
        { id: 0, name: translate("common.status_inactive") },
        { id: 1, name: translate("common.status_active") },
    ]
    const GENDER = [
        { id: 0, name: '不明' },
        { id: 1, name: '男性' },
        { id: 2, name: '女性' },
        { id: 3, name: '未選択'}

    ]
    if (role ===undefined) {
        return null;
    }
    return (
        <List
            {...props}
            filters={<UserFilter />}
            sort={{ field: 'id', order: 'DESC' }}
            perPage={25}
            //filterDefaultValues={{ kuchikomi_user: false }}
            bulkActionButtons={<UserBulkActionButtons />}
            pagination={<ListPagination />}
            exporter={(items: any,fetchRelatedRecords:any) => exporter(items,fetchRelatedRecords)}
            actions={<ListActions to='user' />}
            empty={<ListEmpty />}
            filterDefaultValues={{ is_soft_deleted: false }}
            title={translate('menu.user.user_list')}
        >
            <CustomizableDatagrid>
                <TextField source="id" label={translate('user_list.id')} />
                <TextField source="lastname" label={translate('user_list.lastname')} />
                <TextField source="firstname" label={translate('user_list.firstname')} />
                <TextField source="lastname_kana" label={translate('user_list.lastname_kana')} />
                <TextField source="firstname_kana" label={translate('user_list.firstname_kana')} />
                <ReferenceField label={translate('user_list.account_id')} source="account_id" reference="account">
                    <TextField source="name" />
                </ReferenceField>
                <EmailField source="email" label={translate('user_list.email')} />
                <TextField source="post_code" label={translate('user_list.post_code')} />
                <TextField source="pref" label={translate('user_list.pref')} />
                <TextField source="city" label={translate('user_list.city')} />
                <TextField source="birthday" label={translate('user_list.birthday')} />
                <StatusField source='status' label={translate('user_list.status')}/>
                <TextField source="phone" label={translate('user_list.phone')} />
                <TextField source="address" label={translate('user_list.address')} />
                <SelectField source="gender" choices={GENDER} label={translate('user_list.gender')} />
                <TextField source="nickname" label={translate('user_list.nickname')} />
                <DateField source="created" label={translate('user_list.created_email')} showTime={true} locales="ja-JP" />
                <DateField source="varified" label={translate('user_list.varified')} showTime={true} locales="ja-JP" />
                <TextField source="note" label={translate('user_list.note')} />
            </CustomizableDatagrid>
        </List>
    );
};

export default UserList;
